<div #container [ngClass]="{ simplified: simplified }"></div>
